import type { Product } from '@/types/product';

export const mockProducts: Product[] = [
  {
    id: '1',
    name: 'Professional DSLR Camera',
    sku: 'ELEC-1001',
    description: 'High-end digital camera with 24.2MP sensor and 4K video capabilities. Perfect for professional photography and videography.',
    category: 'equipment',
    status: 'active',
    basePrice: 899.99,
    currentStock: 15,
    minimumStock: 5,
    unit: 'piece',
    specifications: [
      { key: 'Resolution', value: '24.2MP' },
      { key: 'Video', value: '4K/60fps' },
      { key: 'Sensor', value: 'Full-frame CMOS' }
    ],
    images: ['https://images.unsplash.com/photo-1516035069371-29a1b244cc32'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '2',
    name: 'Ergonomic Office Chair',
    sku: 'FURN-2001',
    description: 'Premium mesh office chair with lumbar support and adjustable armrests. Designed for all-day comfort.',
    category: 'equipment',
    status: 'active',
    basePrice: 299.99,
    currentStock: 25,
    minimumStock: 10,
    unit: 'piece',
    specifications: [
      { key: 'Material', value: 'Mesh' },
      { key: 'Weight Capacity', value: '300 lbs' },
      { key: 'Adjustable Height', value: 'Yes' }
    ],
    images: ['https://images.unsplash.com/photo-1505797149-35ebcb05a6fd'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '3',
    name: 'Premium Coffee Beans',
    sku: 'FOOD-3001',
    description: 'Specialty grade Arabica coffee beans, medium roast. Sourced from sustainable farms in Colombia.',
    category: 'food-beverage',
    status: 'active',
    basePrice: 24.99,
    currentStock: 100,
    minimumStock: 30,
    unit: 'kg',
    specifications: [
      { key: 'Origin', value: 'Colombia' },
      { key: 'Roast', value: 'Medium' },
      { key: 'Type', value: 'Arabica' }
    ],
    images: ['https://images.unsplash.com/photo-1447933601403-0c6688de566e'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '4',
    name: 'Wireless Microphone Set',
    sku: 'ELEC-1002',
    description: 'Professional wireless microphone system with dual receivers. Ideal for events and presentations.',
    category: 'equipment',
    status: 'active',
    basePrice: 449.99,
    currentStock: 12,
    minimumStock: 4,
    unit: 'set',
    specifications: [
      { key: 'Range', value: '100m' },
      { key: 'Battery Life', value: '8 hours' },
      { key: 'Frequency', value: 'UHF' }
    ],
    images: ['https://images.unsplash.com/photo-1590602847861-f357a9332bbc'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '5',
    name: 'LED Party Lights',
    sku: 'DECO-5001',
    description: 'RGB LED light strips with remote control and music sync capabilities. Perfect for creating ambiance.',
    category: 'decorations',
    status: 'active',
    basePrice: 79.99,
    currentStock: 50,
    minimumStock: 15,
    unit: 'set',
    specifications: [
      { key: 'Length', value: '10m' },
      { key: 'Colors', value: 'RGB' },
      { key: 'Control', value: 'Remote + App' }
    ],
    images: ['https://images.unsplash.com/photo-1586699253884-e199770f63b9'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '6',
    name: 'Premium Paper Supplies',
    sku: 'SUPP-6001',
    description: 'High-quality cardstock and paper supplies for event invitations and programs.',
    category: 'supplies',
    status: 'active',
    basePrice: 34.99,
    currentStock: 200,
    minimumStock: 50,
    unit: 'box',
    specifications: [
      { key: 'Weight', value: '120gsm' },
      { key: 'Size', value: 'A4' },
      { key: 'Sheets/Box', value: '250' }
    ],
    images: ['https://images.unsplash.com/photo-1517697471339-4aa32003c11a'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '7',
    name: 'Portable Stage Platform',
    sku: 'EQUIP-7001',
    description: 'Modular stage platform with adjustable height. Easy to assemble and transport.',
    category: 'equipment',
    status: 'active',
    basePrice: 599.99,
    currentStock: 8,
    minimumStock: 2,
    unit: 'piece',
    specifications: [
      { key: 'Size', value: '4x8 ft' },
      { key: 'Height', value: 'Adjustable 1-3 ft' },
      { key: 'Weight Capacity', value: '1000 lbs' }
    ],
    images: ['https://images.unsplash.com/photo-1516450360452-9312f5e86fc7'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '8',
    name: 'Gourmet Appetizer Platters',
    sku: 'FOOD-3002',
    description: 'Selection of premium appetizers including cheeses, meats, and vegetables. Perfect for corporate events.',
    category: 'food-beverage',
    status: 'active',
    basePrice: 149.99,
    currentStock: 0,
    minimumStock: 5,
    unit: 'set',
    specifications: [
      { key: 'Serves', value: '25-30 people' },
      { key: 'Dietary', value: 'Various Options' },
      { key: 'Preparation', value: 'Ready to Serve' }
    ],
    images: ['https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '9',
    name: 'Event Backdrop Stand',
    sku: 'DECO-5002',
    description: 'Professional backdrop stand with adjustable width and height. Includes carrying case.',
    category: 'decorations',
    status: 'active',
    basePrice: 189.99,
    currentStock: 20,
    minimumStock: 5,
    unit: 'set',
    specifications: [
      { key: 'Width', value: '6-10 ft' },
      { key: 'Height', value: '6-8 ft' },
      { key: 'Material', value: 'Aluminum' }
    ],
    images: ['https://images.unsplash.com/photo-1505236858219-8359eb29e329'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '10',
    name: 'Wireless Presentation Clicker',
    sku: 'ELEC-1003',
    description: 'Professional presentation remote with laser pointer and slide controls. Compatible with all major presentation software.',
    category: 'equipment',
    status: 'active',
    basePrice: 49.99,
    currentStock: 30,
    minimumStock: 10,
    unit: 'piece',
    specifications: [
      { key: 'Range', value: '30m' },
      { key: 'Battery', value: 'AAA x 2' },
      { key: 'Compatibility', value: 'Windows/Mac' }
    ],
    images: ['https://images.unsplash.com/photo-1586769852044-692d6e3703f0'],
    createdAt: '2024-03-15T00:00:00Z',
    updatedAt: '2024-03-15T00:00:00Z',
    createdBy: 'system',
    updatedBy: 'system'
  }
];